import Types from "./types";

const INITIAL_STATE = {
  loading: false,
  error: null,
  data: [],
  page_num: 1,
  results_per_page: 25,
  result_count: 0,
  total_page_num: 1,
  filters: {
    search_term: "",
    language_id: null,
    location_id: null,
    approved: true,
  },
};

export default function cachePagesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.FETCH_CACHEPAGES_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

case Types.FETCH_CACHEPAGES_SUCCESS: {
  const p = action.payload || {};
  const rows = Array.isArray(p.data) ? p.data : Array.isArray(p?.data?.data) ? p.data.data : [];

  return {
    ...state,
    loading: false,
    error: null,
    data: rows,
    page_num: p.page_num ?? p?.data?.page_num ?? 1,
    results_per_page: p.results_per_page ?? p?.data?.results_per_page ?? state.results_per_page,
    result_count: p.result_count ?? p?.data?.result_count ?? 0,
    total_page_num: p.total_page_num ?? p?.data?.total_page_num ?? 1,
  };
}


    case Types.FETCH_CACHEPAGES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error || true,
      };

    case Types.SET_CACHEPAGES_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...(action.payload || {}),
        },
      };

    case Types.UPDATE_CACHEPAGES_BEGIN:
      return { ...state, loading: true, error: null };

    case Types.UPDATE_CACHEPAGES_SUCCESS:
      return { ...state, loading: false, error: null };

    case Types.UPDATE_CACHEPAGES_ERROR:
      return { ...state, loading: false, error: action.error || true };

    default:
      return state;
  }
}
